import React, { Fragment, useMemo, useState } from 'react';
import AppTable from '../../../constants/AppTable';
import { LoadingSpinner } from '../../../constants/AppLoading';
import DialogBox from '../../../constants/DialogBox';
import { Grid } from '@mui/material';
import InputTextBox from '../../../constants/InputTextBox';
import { toleValidationSchema } from '../../../helpers/validation';
import { useFormik } from 'formik';
import NepaliInputBox from '../../../constants/NepaliInputBox';
import { handleNepaliInputChange } from '../../../helpers/handleChange';
import { EndBaseLine } from '../../../constants/AppSpace';
import { Button } from '../../../constants/Button';
import { putDataToTheServer } from '../../../helpers/api';
import AppURL from '../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../constants/Toast';

interface Caste {
    caste_id: number;
    caste_name: string;
    caste_name_nep: string;
}

interface CasteListViewProps {
    data: {
        results: Caste[];
        previous: string | null;
        next: string | null;
    } | null;
    loading: boolean;
    error: string | null;
    setOnURL: React.Dispatch<React.SetStateAction<string>>;
    handleFormSuccess: () => void;
}

const CasteListView: React.FC<CasteListViewProps> = ({ data, loading, error, handleFormSuccess, setOnURL }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [currentItem, setCurrentItem] = useState<Caste | null>(null);

    const columns = [
        { header: 'SN', accessor: 'caste_id', sortable: false },
        { header: 'Caste Name', accessor: 'caste_name', sortable: true },
        { header: 'Caste Name(Nepali)', accessor: 'caste_name_nep', sortable: false },
        { header: 'Actions', accessor: 'actions', action: true },
    ];

    const modifiedData = useMemo(() => {
        if (!data) return [];
        return data.results.map((item: Caste) => ({
            caste_id: item.caste_id, // Include caste_id
            caste_name: item.caste_name,
            caste_name_nep: item.caste_name_nep,
        }));
    }, [data]);
    

    const handleEdit = (item: Caste) => {
        setCurrentItem(item);
        setDialogOpen(true);
    };

    const formik = useFormik({
        initialValues: {
            caste_name: currentItem?.caste_name || "",
            caste_name_nep: currentItem?.caste_name_nep || "",
        },
        // validationSchema: toleValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("caste_name", values.caste_name);
            formData.append("caste_name_nep", values.caste_name_nep);
            try {
                await putDataToTheServer(AppURL.FrontOfficeURL + 'front/caste/retrieve/update/view/'+currentItem?.caste_id, formData).then((res) => {
                    if(res?.status===200){
                        handleFormSuccess();
                        setDialogOpen(false);
                        ToastSuccess({ message: res?.message });
                    }else if(res?.status===400){
                        ToastWarning({ message: res?.message?.caste_name_nep });
                    }
                    else{
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingSpinner />
            </div>
        );
    }

    if (error) {
        return <p>Error loading data: {error}</p>;
    }
    return (
        <Fragment>
            <AppTable
                columns={columns}
                data={modifiedData}
                onEdit={handleEdit}
                onNext={() => data?.next && setOnURL(data.next)}
                onPrev={() => data?.previous && setOnURL(data.previous)}
            />
            {dialogOpen && currentItem && (
                <DialogBox open={dialogOpen} headerName='Caste Edit Update' close={() => setDialogOpen(false)}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columnSpacing={3} rowSpacing={0.8}>
                            <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='caste_name'
                                    label='Caste Name'
                                    handleChange={formik.handleChange}
                                    value={formik.values.caste_name}
                                    error={typeof formik.errors.caste_name === 'string' ? formik.errors.caste_name : undefined}
                                    handleBlur={formik.handleBlur}
                                    touched={formik.touched.caste_name}
                                    required={true}
                                    placeholder='Enter Caste Name'
                                />
                            </Grid>
                            <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                                <NepaliInputBox
                                    label='Caste Name(Nepali)'
                                    name='tole_name_nep'
                                    value={formik.values.caste_name_nep}
                                    handleChange={(e) => handleNepaliInputChange(e, { setFieldValue: formik.setFieldValue, name: 'caste_name_nep' })}
                                    required={true}
                                    handleBlur={formik.handleBlur}
                                    error={typeof formik.errors.caste_name_nep === 'string' ? formik.errors.caste_name_nep : undefined}
                                    placeholder='Enter Caste nepali name'
                                    touched={formik.touched.caste_name_nep}
                                />
                            </Grid>
                            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <EndBaseLine top={18}>
                                    <Button btn_type='save' type='submit' el='button' />
                                </EndBaseLine>
                            </Grid>
                        </Grid>
                    </form>
                </DialogBox>
            )}
        </Fragment>
    );
};

export default CasteListView;
